import type { TNavigationState } from "../types/navbar";

export function useNavigation() {
  const navigationState = useState<TNavigationState>(
    "layoutNavigation",
    () => ({
      openedNavigationDropDownId: null,
      mobileDrawerOpen: false,
    }),
  );

  const closeAll = () => {
    navigationState.value.mobileDrawerOpen = false;
    navigationState.value.openedNavigationDropDownId = null;
  };

  const toggleMobileDrawer = () => {
    navigationState.value.mobileDrawerOpen =
      !navigationState.value.mobileDrawerOpen;
  };

  const toggleSubMenu = (id: string | null) => {
    navigationState.value.openedNavigationDropDownId =
      navigationState.value.openedNavigationDropDownId === id ? null : id;
  };

  onMounted(() => window.addEventListener("resize", closeAll));
  onUnmounted(() => window.removeEventListener("resize", closeAll));

  return {
    navigationState,
    toggleMobileDrawer,
    toggleSubMenu,
    closeAll,
  };
}
